// extracted by mini-css-extract-plugin
export var childrenContainer = "_1b-0";
export var virtualScrollArea = "_1b-1";